import { useParams } from "react-router-dom";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";
import AssignPackages from "../../components/UnifiedSearchList/AssignPackages/AssignPackages";

export default function AssignPackagesPage() {
  const { uuid, id } = useParams();

  return (
    <PaginationProvider>
      <ModalProvider>
        <AssignPackages uuid={uuid} fanId={id} />
      </ModalProvider>
    </PaginationProvider>
  );
}
